import React from 'react';
import styled from 'styled-components';
import { PlatformAdminRow } from '../../../../../models/entities/platform/platformSuperAdmin';
import Grid from '../../../../shared/Grid/Grid';
import Loader from '../../../../shared/SmallComponents/Loader';
import platformSuperAdminsGridColumns from './platformSuperAdminsGridColumns';

type Props = {
    rows: PlatformAdminRow[];
    showLoader: boolean;
    localization: any;
    onRevoke: (email: string) => void;
};

const PlatformSuperAdminsGrid = ({ rows, showLoader, localization, onRevoke }: Props) => {
    if (showLoader) {
        return <Loader />;
    }

    return (
        <Wrapper>
            <Grid<PlatformAdminRow>
                columns={platformSuperAdminsGridColumns({ onRevoke, localization })}
                data={rows}
                localization={localization.grid}
                emptyStateText={localization.grid.empty_state}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 100%;
    height: 100%;

    .MuiDataGrid-root {
        border: none;
    }
`;

export default PlatformSuperAdminsGrid;
